import React , {useEffect, useState , useContext , useRef} from "react";
import Navbar from "../components/navbar";
import slide1 from "../assets/Royal Caribbeanhead2.webp";
import slide2 from "../assets/princesshead2.webp";
import slide3 from "../assets/nclhead-2.webp";
import destination from "../components/DestinationData.jsx";
import Brand from "../components/BrandMaking.jsx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight , faArrowLeft} from '@fortawesome/free-solid-svg-icons';
import BrandDeal from "../components/BrandDeal.jsx";
import DestinationCard from "../components/DestinationCard.jsx";
import Footer from "../components/Footer.jsx";
import ScrolltoTop from "../components/ScrolltoTop.jsx";
import { CurrencyContext } from "../components/CurrencyContext";
import UTMHandler from "../components/UTMHandler.jsx";
import AutoShowModal from "../components/AutoShowModal.jsx";


const deallink = {
  INR:"https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&dynamicsupplierpromo=BEV,DISCOUNT,BOGO,NRD,WIFI,ALL,RETREAT,CSTAllInc,DINING&sortcolumn=cruiselinePriority&sortorder=asc",
  SGD:"https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&dynamicsupplierpromo=BEV,DISCOUNT,BOGO,NRD,WIFI,ALL,RETREAT,CSTAllInc,DINING&sortcolumn=cruiselinePriority&sortorder=asc",
  USD:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&dynamicsupplierpromo=BEV,DISCOUNT,BOGO,NRD,WIFI,ALL,RETREAT,CSTAllInc,DINING&sortcolumn=cruiselinePriority&sortorder=asc"

}


const curencylink = {

  Royal: {
  INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&cruiseline=8&dynamicsupplierpromo=BOGO,NRD,DISCOUNT,OBC&sortcolumn=cruiselinePriority&sortorder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=8&dynamicsupplierpromo=BOGO,NRD,DISCOUNT,OBC&sortcolumn=cruiselinePriority&sortorder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=8&dynamicsupplierpromo=BOGO,NRD,DISCOUNT,OBC&sortcolumn=cruiselinePriority&sortorder=asc"
},

  Princess: {
  "INR" :"https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&cruiseline=7&sortcolumn=cruiselinePriority&sortorder=asc",
  "SGD" : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=7&sortcolumn=cruiselinePriority&sortorder=asc",
  "USD" :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=7&sortcolumn=cruiselinePriority&sortorder=asc"
} ,

 Ncl: {
  "INR" :"https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&cruiseline=6&sortcolumn=cruiselinePriority&sortorder=asc",
  "SGD" : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=6&sortcolumn=cruiselinePriority&sortorder=asc",
  "USD" :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=6&sortcolumn=cruiselinePriority&sortorder=asc"
}
}

const CruiseDeals =()=> {
    //  Destination
  
  const [index, setIndex] = useState(0);

   const currency = useContext(CurrencyContext);
  
  const [cardsPerView, setCardsPerView] = useState(3);

    const containerRef = useRef(null);
    const touchStartX = useRef(0);
    const touchEndX = useRef(0);

  // Array of only the selected deals
  const selectedDeals = [destination[0], destination[1], destination[2] , destination[3], destination[4], destination[5], destination[6], destination[7]];

  const maxIndex = selectedDeals.length - cardsPerView;

  useEffect(() => {
    const updateCardsPerView = () => {
      setCardsPerView(window.innerWidth < 768 ? 1 : 3);
    };
    updateCardsPerView();
    window.addEventListener('resize', updateCardsPerView);
    return () => window.removeEventListener('resize', updateCardsPerView);
  }, []);

  
    // Auto-slide every 3 seconds
      useEffect(() => {
        const interval = setInterval(() => {
          setIndex(prev => (prev >= maxIndex ? 0 : prev + 1));
        }, 5000);
        return () => clearInterval(interval);
      }, [maxIndex]);
    
       // Swipe handlers
    const handleTouchStart = (e) => {
      touchStartX.current = e.touches[0].clientX;
    };
  
    const handleTouchMove = (e) => {
      touchEndX.current = e.touches[0].clientX;
    };
  
     const handleTouchEnd = () => {
      const diff = touchStartX.current - touchEndX.current;
      if (diff > 50) {
        // Swipe left
        setIndex(prev => (prev >= maxIndex ? 0 : prev + 1));
      } else if (diff < -50) {
        // Swipe right
        setIndex(prev => (prev <= 0 ? maxIndex : prev - 1));
      }
    };
  
  

  // const handlePrev = () => {
  //   setIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  // };
  
  // const handleNext = () => {
  //   setIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  // };

  const visibleDeals = selectedDeals.slice(index, index + cardsPerView);



  //  Brand Deal
  const [bdindex, bdsetIndex] = useState(0);
  
  const [bdcardsPerView, bdsetCardsPerView] = useState(3);

   const bdcontainerRef = useRef(null);
      const bdtouchStartX = useRef(0);
      const bdtouchEndX = useRef(0);
  

  // Array of only the selected deals
  const bdselectedDeals = [BrandDeal[0], BrandDeal[1], BrandDeal[2] , BrandDeal[3], BrandDeal[4], BrandDeal[5], BrandDeal[6], BrandDeal[7], BrandDeal[8], BrandDeal[9], BrandDeal[10], BrandDeal[11]];
  const bdmaxIndex = bdselectedDeals.length - bdcardsPerView;


  useEffect(() => {
    const bdupdateCardsPerView = () => {
      bdsetCardsPerView(window.innerWidth < 768 ? 1 : 3);
    };
    bdupdateCardsPerView();
    window.addEventListener('resize', bdupdateCardsPerView);
    return () => window.removeEventListener('resize', bdupdateCardsPerView);
  }, []);


  
   // Auto-slide every 3 seconds
      useEffect(() => {
        const interval = setInterval(() => {
          bdsetIndex(prev => (prev >= bdmaxIndex ? 0 : prev + 1));
        }, 5000);
        return () => clearInterval(interval);
      }, [bdmaxIndex]);
    
       // Swipe handlers
    const bdhandleTouchStart = (e) => {
      bdtouchStartX.current = e.touches[0].clientX;
    };
  
    const bdhandleTouchMove = (e) => {
      bdtouchEndX.current = e.touches[0].clientX;
    };
  
     const bdhandleTouchEnd = () => {
      const diff = bdtouchStartX.current - bdtouchEndX.current;
      if (diff > 50) {
        // Swipe left
        bdsetIndex(prev => (prev >= bdmaxIndex ? 0 : prev + 1));
      } else if (diff < -50) {
        // Swipe right
        bdsetIndex(prev => (prev <= 0 ? bdmaxIndex : prev - 1));
      }
    };

  // const bdhandlePrev = () => {
  //   bdsetIndex((prev) => (prev <= 0 ? bdmaxIndex : prev - 1));
  // };
  
  // const bdhandleNext = () => {
  //   bdsetIndex((prev) => (prev >= bdmaxIndex ? 0 : prev + 1));
  // };

  const bdvisibleDeals = bdselectedDeals.slice(bdindex, bdindex + bdcardsPerView);


    return(
        <>

       <UTMHandler/>
        <div className="about-navbar">
        <Navbar/>
        </div>
        <div className="offer-banner">
           <a href={deallink[currency.currencyCode]} target="_blank"  rel="noreferrer"  style={{textDecoration:'none' , color:'white', cursor:'pointer'}}><h5>Last Call On Cruise Deals - Book Now </h5></a>
        </div>


        
    <div class= "ajslider ">
    <div id="carouselExampleIndicators" class="carousel slide ajslider-container " data-bs-ride="carousel" data-bs-interval="3000">

   <div class="carousel-indicators" >
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
    {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

  </div>
  <div class="carousel-inner laptop-responsive-carousel">
    <div class="carousel-item active ">
<a href={curencylink.Royal[currency.currencyCode]} target="_self" rel="noopener noreferrer">
      <img src={slide1} class="d-block w-100 " alt="..."/>
      </a>
    </div>
    <div class="carousel-item ">
<a href={curencylink.Princess[currency.currencyCode]} target="_self" rel="noopener noreferrer">
      <img src={slide2} class="d-block w-100 " alt="..."/>
      </a>
    </div>
     <div class="carousel-item mobile">
      <a href={curencylink.Ncl[currency.currencyCode]} target="_self" rel="noopener noreferrer">
      <img src={slide3} class="d-block w-100" alt="..."/>
      </a>
    </div>
    {/* <div class="carousel-item mobile">
      <img src={mobile2} class="d-block w-100" alt="..."/>
    </div>  */}
  </div>

 
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
  </div>

  </div>

 <div className="Section-3">
                 
         <h2>Pick Your Perfect Destinations</h2>

         <div className="carousel-wrapper" >

       <div className="button-style">
        <button  onClick={() => setIndex(prev => (prev <= 0 ? maxIndex : prev - 1))}style={{backgroundColor:'transparent', border:'none'}} >
           {/* <img src={Pre} alt="Previos button" /> */}
           <FontAwesomeIcon icon={ faArrowLeft} style={{color:"#164D55" , fontSize:'1.8rem'}} className="backward-icon" />
        </button>

        <button onClick={() => setIndex(prev => (prev >= maxIndex ? 0 : prev + 1))} style={{backgroundColor:'transparent', border:'none'}}  >
            {/* <img src={Next} alt= "Next button" /> */}
            <FontAwesomeIcon icon={ faArrowRight} style={{color:"#164D55" , fontSize:'1.8rem'}} className="forward-icon"/>
        </button>

        </div>

        <div className="trip" 
        ref={containerRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          style={{ display: 'flex', gap: '20vh' , transition: 'transform 0.5s ease-in-out' , marginTop:'5vh'}}>
           {visibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.links[currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <DestinationCard img={deal.img} name={deal.name} />
          </a>
        ))}
        </div>
        
        
        </div>

      </div>

      <div className="Section-4 cruise-line-page">
                 
         <h2>Choose Your Cruise Line</h2>

         <div className="carousel-wrapper" >

       <div className="button-style">
        <button onClick={() => bdsetIndex(prev => (prev <= 0 ? bdmaxIndex : prev - 1))}  style={{backgroundColor:'transparent', border:'none'}} >
           <FontAwesomeIcon icon={ faArrowLeft} style={{color:"#164D55" , fontSize:'1.8rem'}} className="backward-icon"/>
          
           {/* <img src={Pre} alt="Previos button" /> */}
        </button>

        <button onClick={() => bdsetIndex(prev => (prev >= bdmaxIndex ? 0 : prev + 1))} style={{backgroundColor:'transparent', border:'none'}}  >
            <FontAwesomeIcon icon={ faArrowRight} style={{color:"#164D55" , fontSize:'1.8rem'}} className="forward-icon"/>
            {/* <img src={Next} alt= "Next button" /> */}
        </button>

        </div>

        <div className="trip" 
        ref={bdcontainerRef}
        onTouchStart={bdhandleTouchStart}
          onTouchMove={bdhandleTouchMove}
          onTouchEnd={bdhandleTouchEnd}
        style={{ display: 'flex', gap: '15vh' , transition: 'transform 0.5s ease-in-out' , marginTop:'3vh'}}>
           {bdvisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.links[currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Brand img={deal.img} offer={deal.offer} brand={deal.brand} />
          </a>
        ))}
        </div>
        
        
        </div>

      </div>

<ScrolltoTop/>

<AutoShowModal/>
    <Footer/>

        </>
     
        

    );
}

export default CruiseDeals;